<template>
  <div class="cross">
    <login-header v-bind="headerInfo"></login-header>
    <div class="content" v-loading="loading">

    </div>
    <login-footer :description="desc"></login-footer>
  </div>
</template>
<script>
import loginHeader from '../header'
import loginFooter from '../footer'
import qs from 'qs'
export default {
  name: 'crossIndex',
  components: {
    loginHeader,
    loginFooter
  },
  data() {
    return {
      loading: true,
      hostUrl: '', // 当前域名
      headerInfo: {
        type: '选择店铺',
        userDisplayFlag: false,
        userName: '',
        logo: ''
      },
      desc: ''
    }
  },
  created() {
    // 获取当前域名
    const hostName = window.location.hostname
    if (hostName !== 'www.zvcms.com') {
      const n = hostName.indexOf('.')
      if (n) {
        const host = hostName.substring(n + 1, hostName.length)
        if (host.length > 0) {
          this.hostUrl = host
        }
      }
    } else {
      this.hostUrl = 'zmcms.cn'
      // this.hostUrl = 'zvcms.com'
    }

    // 获取路由传的参数
    if (this.$route.query.c_key) {
      this.setCookie(this.$route.query.c_key, this.$route.query.c_value, this.$route.query.c_expire, this.hostUrl)
    }
    let myDate = new Date()
    const localYear = myDate.getFullYear()
    // 如果是其他机构再请求接口
    if (this.hostUrl != 'zmcms.cn' && this.hostUrl != 'qimai.shop' && this.hostUrl != 'qmai.cn') {
      // 授权登录接口
      this.getInfo()
    } else { // 企迈环境顶部和底部信息设置
      var info = {
        name: '企迈云商',
        logo: 'https://img-shop.qmimg.cn/s16/images/2019/06/18/d76b9262c466ba5d.png',
        desc: `<p><a href="https://www.qmai.cn" target="_blank">安徽智迈科技股份有限公司</a> 版权所有 Copyright 2009-${localYear} 皖公网安备34019202000074号&nbsp; 增值电信业务经营许可证：皖B2-20170075</p>`
        // <p><img width="11px" src="https://img-shop.qmimg.cn/public/img/ico_safe.png"/>&nbsp;通过ISO27001:2013 信息安全认证通过ISO9001:2008质量管理体系认证</p>
      }
      this.headerInfo.logo = info.logo
      this.desc = info.desc
      document.title = info.name
      localStorage.setItem('xdata', qs.stringify(info))
      localStorage.setItem('title', info.name)
      this.getLogin()
    }
  },
  methods: {
    setCookie(name, value, time, domainPrefix) { // 设置cookie
      var exp = new Date()
      exp.setTime(exp.getTime() + time * 1000)
      document.cookie = name + '=' + value + ';expires=' + exp.toGMTString() + ';domain=' + domainPrefix + ';path=/'
      // document.cookie = name + "=" + value + "; " + "expires=" + exp.toGMTString() + "; " + "max_age=" + time + "; " + "path=/; " + "domain=" + domainPrefix + ";";
    },
    getInfo() { // 获取机构信息
      var that = this
      // 授权登录接口
      QM.apinew({
        url: '/seller/organization/info',
        method: 'GET',
        success: function (xdata) {
          // 获取机构信息
          document.title = xdata.data.name // 结构名称
          localStorage.setItem('title', xdata.data.name) //  ？
          localStorage.setItem('xdata', qs.stringify(xdata.data)) //  ？
          that.headerInfo.logo = xdata.data.logo //  logo
          that.desc = xdata.data.desc // 版权信息
          // 请求获取用户信息
          that.getLogin()
        },
        error: function (xdata) {
          that.$message.error(xdata.message)
          that.loading = false
        }
      })
    },
    getLogin() { // 获取登录成功信息
      var that = this
      QM.apinew({
        url: '/seller/user/check-login',
        method: 'post',
        data: {},
        success: function (xdata) {
          localStorage.setItem('mobile', xdata.data.mobile)
          localStorage.setItem('mytoken', xdata.data.id)
          // 绑定成功跳转
          setTimeout(() => {
            that.loading = false
            that.$router.push('/')
          }, 1000)
        },
        error: function (xdata) {
          that.$message.error(xdata.message)
          that.loading = false
          that.$router.push({ path: 'login' })
        }
      })
    }
  }
}
</script>

<style scoped>
  [v-cloak] {
    display: none;
  }
</style>